import * as types from '../../constants/loader';

const initialState = {
  isLoading: true,
};

export default function loaderReducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_LOADER:
      return {
        ...state,
        isLoading: true,
      };
    case types.HIDE_LOADER:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
